module.exports = __webpack_public_path__ + "static/media/anniu1.83b6d0f6.png";